
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
      var settings = event.detail.settings;
      var obj = {
        title: 'Wallet',
        url: "#wallet",
        target:0,
        badge: null,
        icon: '<img src="https://cdn.shopify.com/s/files/1/0806/8064/8999/files/wallet-icon.png?v=1704803276">',
        isShow: 1,
        loader:null,
        body_html:'<div id="fc-wallet-activity-snippet-19212"></div>'
      }
      var wishlistObj = {
          title: 'My wishlist',
          url: "#myWishlist",
          target:0,
          badge: null,
          icon: '<img src="https://cdn.shopify.com/s/files/1/0806/8064/8999/files/wishlist-icon.png?v=1704803277">',
          isShow: 1,
          loader:null,
          body_html:'<div id="swym-wishlist-render-container"></div>'
        }
      settings.navs.splice(5, 0, obj);
      settings.navs.splice(6, 0, wishlistObj);
    
  });
  Flits(document).on('Flits:AccountPage:Loaded',function(params) {
    if ($(window).width() < 768) {
      Flits('.flits-desktop-view').find('#flits_tab_wallet .flits-box-card').html('');
      Flits('.flits-desktop-view').find('#flits_tab_myWishlist .flits-box-card').html('');
    }
      // Create a script element with the dynamic attributes
      var scriptElement = $('<script>')
        .attr('src', 'https://static.farziengineer.co/farziwallet/wallet-activity-snippet.js?v=2')
        .attr('defer', true)
        .attr('id', 'fc-wallet-activity-snippet-script-19212')
        .attr('data-customer-id', `${Flits.customer_id}`)
        .attr('data-customer-tag', `${window.flitsObjects.storeData.customer_tag}`)
        .attr('data-client-id', 'Q2xpZW50OjEx');

      // Append the script element to the body
      $('body').append(scriptElement);

 var scriptContent = "\
        window.SwymCallbacks = window.SwymCallbacks || [];\n\
        window.SwymCallbacks.push(function(swat) {\n\
          var wishlistContainerElement = document.querySelector(\"#swym-wishlist-render-container\");\n\
          var queryParams = swat.utils.getEncodedAsObject(window.location.search);\n\
          // Contains queryParams[\"lid\"];\n\
          swat.ui.renderWishlistInContainer(wishlistContainerElement, queryParams);\n\
        });";

      // Create a script element with the dynamic content
      var scriptElement = $('<script>')
        .attr('type', 'text/javascript')
        .html(scriptContent);

      // Append the script element to the body
      $('body').append(scriptElement);
  });
}(Flits));
